var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../../../Icon";
import { Button } from "../../../Button";
// styles
import "./sidebarHeader.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-sidebarHeader",
};
const SidebarHeader = (_a) => {
    var { headerIcon, toggleIconOnClose, toggleIconOnOpen, toggleLabel, onToggle, isOpen, className } = _a, rest = __rest(_a, ["headerIcon", "toggleIconOnClose", "toggleIconOnOpen", "toggleLabel", "onToggle", "isOpen", "className"]);
    const classList = classNames("tecma-sidebarHeader", { isOpen }, className);
    const handleToggle = () => {
        if (onToggle) {
            onToggle();
        }
        else {
            throw new Error("missing toggle function");
        }
    };
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [headerIcon && _jsx(Icon, { iconName: headerIcon, size: "large" }), _jsxs("div", { className: "sidebarHeader-toggleSection", children: [_jsx("span", { children: toggleLabel }), _jsx(Button, { iconName: isOpen ? toggleIconOnOpen : toggleIconOnClose, onClick: () => handleToggle(), link: true })] })] })));
};
SidebarHeader.defaultProps = defaultProps;
export default React.memo(SidebarHeader);
